import { ThemeUICSSObject } from '@apia/theme';

/**
 * El gridEdition tiene una estructura muy particular:
 *
 * Overlay > Modal > !!! iframe !!!
 *
 * iframe > ...
 *
 * Por este motivo no se pueden aplicar ni todos los estilos desde fuera
 * (overlay), ni todos los estilos desde dentro (document)
 *
 * @see
 *
 * layout.common.modals.iframeOverlay
 * layout.common.modals.gridEdition
 * layout.common.modals.overlayClassnames.gridEdition
 * layout.execution.form.editGrid
 */
const gridEdition: ThemeUICSSObject = {
  '.tabs__render, .tabs__render__child, .formsContainer, .confirm': {
    height: '100%',
  },
};

export default gridEdition;
